import clsx from "clsx";
import { AlertsContext } from "context/AlertsContext";
import { useContext, useState } from "react";
import {
  SvgCalendar,
  SvgCamera,
  SvgAlertShowPd,
  SvgAlertShowNotes,
  SvgAlertShareAlert,
  SvgAlertDownload,
  SvgAlertPrevPage,
  SvgAlertNextPage,
  SvgAlertToPlayBack,
  SvgMergeAlertToCase,
  SvgGptAnalysis,
  SvgAlertLocation,
  SvgAddToDatabse,
  SvgSeachImg,
} from "ui/svgs";
import AlertMergeCaseModal from "ui/dealer-focus/alert-merge-case-modal";
import AlertStatusChanger from "ui/alerts/alert-status-changer";
import { ALERT_PROCESS_STATUS_SDK } from "lib/constants";
import { AuthContext } from "context/AuthContext";
import { getAlertIcon, showToast } from "ui/components/common";
import moment from "moment";
import PlaybackModal from "ui/playback/playback-modal";
import ShareAlertModal from "ui/alerts/share-alert-modal";
import { useService } from "../../pages/dashboard/alerts/service";
import { SideviewContext } from "context/SideviewContext";
import { Popover } from "react-tiny-popover";
import { Popover as PopoverAntd } from "antd";
import Contacts from "ui/cases/contacts";
import {
  formatContextDate,
  downloadFromSrc,
  getEventText,
  downloadVideoUrl,
  copyToClipBoard,
} from "lib/utils";
import { Tooltip } from "antd";

import GptAnalysisModal from "ui/alerts/gpt-analysis-modal";
import AlertMap from "ui/alerts/alertMap";
import { APIProvider } from "@vis.gl/react-google-maps";
import RecordModal from "ui/database/record-modal";
import CropAlertImgForGptRawModal from "ui/alerts/alert-to-database-modal";
import { AlertDataType } from "lib/types";
import ImgSearchModalControl from "ui/alerts/img-search/img-search-modal-control";

type PropsType = {
  hasNextAlert: boolean;
  hasPreviousAlert: boolean;
  activeAlert: AlertDataType;
  setActiveAlert: (alert: AlertDataType) => void;
  onNextAlert: () => void;
  onPreviousAlert: () => void;
  hiddenButtons?: string[]; // 'alertStatus', 'merge', 'gpt', 'imgSearch', 'addRecord', 'contact', 'note', 'location', 'playback', 'share', 'download', 'previous', 'next'
};
export default function AlertConrolBar(props: PropsType) {
  const {
    hasNextAlert,
    hasPreviousAlert,
    activeAlert,
    setActiveAlert,
    onNextAlert,
    onPreviousAlert,
    hiddenButtons,
  } = props;
  const { user } = useContext(AuthContext);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mergeModalOpen, setMergeModalOpen] = useState(false);
  const [gptModalOpen, setGptModalOpen] = useState(false);
  const [cropAlertAreaModalOpen, setCropAlertAreaModalOpen] = useState(false);
  const [imgSearchModalOpen, setImgSearchModalOpen] = useState(false);
  const [addRecordModalOpen, setAddRecordModalOpen] = useState(false);
  const [playbackModalOpen, setPlaybackModalOpen] = useState(false);
  const [imgCropBlob, setAlertImgBlob] = useState<Blob>();

  const [isContactPopoverOpen, setIsContactPopoverOpen] = useState(false);
  const { setOpenPanel, setViewData } = useContext(SideviewContext);

  const [isDownloadPopoverOpen, setIsDownloadPopoverOpen] = useState(false);

  const { getSnapShotByAlertObj } = useService();
  const [alertMapVisible, setAlertMapVisible] = useState(false);

  const handleToPlayBack = () => {
    setPlaybackModalOpen(true);
  };

  const handleShareAlert = () => {
    setIsModalOpen(true);
  };

  const handlePreviousAlert = () => {
    onPreviousAlert?.();
  };
  const handleNextAlert = () => {
    onNextAlert?.();
  };

  const handleSaveRecord = () => {
    setAddRecordModalOpen(false);
  };

  const handleCropImgUploaded = (imgBlob: Blob) => {
    setCropAlertAreaModalOpen(false);
    setAddRecordModalOpen(true);

    setAlertImgBlob(imgBlob);
  };

  return (
    <>
      <div className="flex flex-col justify-center h-full2 gap-4">
        {/* Control bar */}
        <div
          className="bg-zinc-100 rounded-2xl w-full px-6 py-3 flex-shrink-0"
          style={{ minHeight: "60px" }}
        >
          {/* hide if no license */}
          {activeAlert?.camera?.hasLicense && (
            <div
              className={clsx(
                "flex gap-4 flex-wrap items-center flex-grow w-full",
              )}
            >
              <div className="flex items-center flex-wrap  flex-grow">
                {activeAlert?.eventTypes?.length > 0 && (
                  <div className="flex h-[40px] items-center justify-center rounded-xl  text-neutral-800 text-sm flex-shrink-0 mr-4">
                    {getAlertIcon(activeAlert?.eventTypes[0], true)}
                    <PopoverAntd
                      trigger={activeAlert.isAlert ? undefined : []}
                      content={`The following event detected: ${activeAlert?.eventTypes.join(",")}`}
                      title=""
                    >
                      <p className="text-sm font-semibold text-left p-1">
                        {getEventText(activeAlert?.eventTypes[0])}
                      </p>
                    </PopoverAntd>
                  </div>
                )}

                <div className="flex h-[40px] items-center justify-center rounded-xl  text-neutral-800 text-sm flex-shrink-0 mr-4">
                  <SvgCamera width="22" className="fill-zinc-500" />
                  <p className="text-sm text-left p-1">
                    {activeAlert?.camera?.name || "-"}
                  </p>
                </div>
                <div className="flex h-[40px] items-center justify-center text-neutral-800 text-sm flex-shrink-0 mr-4">
                  <SvgCalendar width="18" className="fill-zinc-500" />
                  <p className="text-sm text-left p-1">
                    {formatContextDate(
                      new Date(Number(activeAlert.createdAt)),
                    ) || "-"}
                  </p>
                </div>
              </div>
              <div className={clsx("flex flex-wrap")}>
                {!hiddenButtons?.includes("alertStatus") &&
                  activeAlert.isAlert && (
                    <div className="pt-1 mr-2 w-32">
                      <AlertStatusChanger alertId={activeAlert?.id} />
                    </div>
                  )}
                {!hiddenButtons?.includes("merge") && (
                  <Tooltip
                    title={
                      activeAlert?.status !==
                        ALERT_PROCESS_STATUS_SDK.Investigate && "Merge"
                    }
                  >
                    <button
                      className="w-[60px] h-[60px] flex items-center justify-center rounded-xl hover:bg-zinc-200 disabled:hover:bg-transparent fill-neutral-800 disabled:opacity-25 disabled:fill-neutral-400"
                      disabled={
                        activeAlert?.status ===
                          ALERT_PROCESS_STATUS_SDK.Investigate ||
                        !activeAlert?.isAlert
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setMergeModalOpen(true);
                      }}
                    >
                      <SvgMergeAlertToCase width="20" />
                    </button>
                  </Tooltip>
                )}
                {!hiddenButtons?.includes("gpt") && (
                  <Tooltip title={"AGI Analysis"}>
                    <button
                      className="w-[60px] h-[60px] flex items-center justify-center rounded-xl hover:bg-zinc-200 disabled:hover:bg-transparent fill-neutral-800 disabled:opacity-25"
                      disabled={false}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setGptModalOpen(true);
                      }}
                    >
                      <SvgGptAnalysis width="28" />
                    </button>
                  </Tooltip>
                )}
                {!hiddenButtons?.includes("imgSearch") && (
                  <Tooltip title={"Image Search"}>
                    <button
                      className="w-[60px] h-[60px] flex items-center justify-center rounded-xl hover:bg-zinc-200 disabled:hover:bg-transparent fill-neutral-800 disabled:opacity-25"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setImgSearchModalOpen(true);
                      }}
                    >
                      <SvgSeachImg width={28} />
                    </button>
                  </Tooltip>
                )}
                {!hiddenButtons?.includes("addRecord") && (
                  <Tooltip title={"Add to Database"}>
                    <button
                      className="w-[60px] h-[60px] flex items-center justify-center rounded-xl hover:bg-zinc-200 disabled:hover:bg-transparent fill-neutral-800 disabled:opacity-25"
                      disabled={false}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setCropAlertAreaModalOpen(true);
                      }}
                    >
                      <SvgAddToDatabse width="28" />
                    </button>
                  </Tooltip>
                )}
                {!hiddenButtons?.includes("contact") && (
                  <Popover
                    isOpen={isContactPopoverOpen}
                    positions={["top", "bottom", "left", "right"]}
                    onClickOutside={() => setIsContactPopoverOpen(false)}
                    content={
                      <div
                        className="bg-white rounded-2xl p-4 w-[700px] overflow-hidden "
                        style={{
                          boxShadow:
                            "0 4px 4px rgba(0,0,0,0.15), 0 -2px 4px rgba(0,0,0,0.15)",
                        }}
                      >
                        <Contacts
                          siteId={activeAlert?.siteId.toString()}
                          maxHeight={350}
                          id={activeAlert?.id}
                          type="alert"
                        />
                      </div>
                    }
                  >
                    <div>
                      <Tooltip title="PD Station">
                        <button
                          disabled={!activeAlert?.isAlert}
                          className="w-[60px] h-[60px] flex items-center justify-center rounded-xl hover:bg-zinc-200 disabled:hover:bg-transparent fill-neutral-800 disabled:fill-neutral-400"
                          onClick={() => setIsContactPopoverOpen(true)}
                        >
                          <SvgAlertShowPd width="28" />
                        </button>
                      </Tooltip>
                    </div>
                  </Popover>
                )}
                {!hiddenButtons?.includes("contact") && (
                  <Tooltip title="Alert Note">
                    <button
                      disabled={!activeAlert?.isAlert}
                      className="w-[60px] h-[60px] flex items-center justify-center rounded-xl hover:bg-zinc-200 disabled:hover:bg-transparent fill-neutral-800 disabled:fill-neutral-400"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const sideviewData = {
                          type: "alert-note",
                          title: "Notes",
                          alertId: activeAlert?.id,
                        };
                        setViewData(sideviewData);
                        setOpenPanel(true);
                      }}
                    >
                      <SvgAlertShowNotes width="20" />
                    </button>
                  </Tooltip>
                )}
                {!hiddenButtons?.includes("location") && (
                  <Tooltip title="View Location">
                    <button
                      disabled={!activeAlert?.isAlert}
                      onClick={() => setAlertMapVisible(true)}
                      className="w-[60px] h-[60px] flex items-center justify-center rounded-xl hover:bg-zinc-200 disabled:hover:bg-transparent fill-neutral-800 disabled:fill-neutral-400"
                    >
                      <SvgAlertLocation width="24" />
                    </button>
                  </Tooltip>
                )}

                {!hiddenButtons?.includes("playback") &&
                  user?.role !== "inspector" &&
                  user?.role !== "operator" && (
                    <Tooltip title="View Playback">
                      <button
                        disabled={!activeAlert?.isAlert}
                        onClick={handleToPlayBack}
                        className="w-[60px] h-[60px] flex items-center justify-center rounded-xl hover:bg-zinc-200 disabled:hover:bg-transparent fill-neutral-800 disabled:fill-neutral-400"
                      >
                        <SvgAlertToPlayBack width="20" />
                      </button>
                    </Tooltip>
                  )}
                {!hiddenButtons?.includes("share") && (
                  <Tooltip title="Share Alert">
                    <PopoverAntd
                      trigger={"click"}
                      color="white"
                      arrow={false}
                      content={
                        <div className="bg-white rounded-[8px] overflow-hidden">
                          <button
                            disabled={!activeAlert?.isAlert}
                            onClick={() => {
                              console.log("copy link activeAlert", activeAlert);
                              const url = `${window.location.origin}/dashboard/alerts/basic?startedAt=${activeAlert?.createdAt}&endedAt=${Number(activeAlert?.createdAt) + 10}&id=${activeAlert?.id}`;
                              copyToClipBoard(url);
                            }}
                            className="block w-full hover:bg2-[#DCE7FD] px-4 h-12 text-neutral-800 hover:text-blue-500"
                          >
                            Copy Alert Link
                          </button>
                          <button
                            disabled={!activeAlert?.isAlert}
                            onClick={handleShareAlert}
                            className="block w-full hover:bg2-[#DCE7FD] px-4 h-12 text-neutral-800 hover:text-blue-500"
                          >
                            Share Alert
                          </button>
                        </div>
                      }
                      title=""
                    >
                      <button
                        disabled={!activeAlert?.isAlert}
                        // onClick={handleToPlayBack}
                        className="w-[60px] h-[60px] flex items-center justify-center rounded-xl hover:bg-zinc-200 disabled:hover:bg-transparent fill-neutral-800 disabled:fill-neutral-400"
                      >
                        <SvgAlertShareAlert width="20" />
                      </button>
                    </PopoverAntd>
                  </Tooltip>
                )}
                {!hiddenButtons?.includes("download") && (
                  <Popover
                    isOpen={isDownloadPopoverOpen}
                    positions={["top", "left", "right", "bottom"]}
                    onClickOutside={() => setIsDownloadPopoverOpen(false)}
                    content={
                      <div
                        className="bg-white rounded-2xl py-2 w-[200px] shadow overflow-hidden"
                        onMouseOut={() => setIsDownloadPopoverOpen(false)}
                        onMouseOver={() => setIsDownloadPopoverOpen(true)}
                      >
                        <button
                          className="block w-full hover:bg-[#DCE7FD] h-12 text-neutral-800"
                          onClick={async () => {
                            try {
                              const blob =
                                await getSnapShotByAlertObj(activeAlert);
                              const formattedName = moment(
                                Number(activeAlert?.createdAt),
                              ).format("MM-DD hh_mm_ss");
                              const fileName = `${activeAlert?.camera?.name}-${formattedName}.jpg`;
                              downloadFromSrc(
                                fileName,
                                URL.createObjectURL(blob),
                              );
                            } catch (e) {
                              showToast(
                                1,
                                "There was a problem fetching the alert snapshot. Please try again later",
                              );
                            }
                          }}
                        >
                          Download Snapshot
                        </button>
                        <button
                          className="block w-full hover:bg-[#DCE7FD] h-12 text-neutral-800 disabled:text-neutral-300 disabled:cursor-not-allowed disabled:hover:bg-transparent"
                          disabled={!activeAlert?.video?.url}
                          onClick={() =>
                            downloadVideoUrl(
                              activeAlert?.video?.url,
                              activeAlert?.camera?.name +
                                "_" +
                                moment(+activeAlert.createdAt).format(
                                  "YYYY-MM-DD_HH_mm_ss",
                                ),
                            )
                          }
                        >
                          Download Video
                        </button>
                      </div>
                    }
                  >
                    <button
                      onClick={() => setIsDownloadPopoverOpen(true)}
                      className="w-[60px] h-[60px] flex items-center justify-center rounded-xl hover:bg-zinc-200 fill-neutral-800"
                    >
                      <SvgAlertDownload width="20" />
                    </button>
                  </Popover>
                )}
                {!hiddenButtons?.includes("previous") && (
                  <Tooltip title={hasPreviousAlert && "Previous Alert"}>
                    <button
                      className="w-[60px] h-[60px] flex items-center justify-center rounded-xl hover:bg-zinc-200 disabled:hover:bg-transparent fill-neutral-800 disabled:opacity-25"
                      disabled={!hasPreviousAlert}
                      onClick={handlePreviousAlert}
                    >
                      <SvgAlertPrevPage width="14" />
                    </button>
                  </Tooltip>
                )}
                {!hiddenButtons?.includes("previous") && (
                  <Tooltip title={hasNextAlert && "Next Alert"}>
                    <button
                      className="w-[60px] h-[60px] flex items-center justify-center rounded-xl hover:bg-zinc-200 disabled:hover:bg-transparent fill-neutral-800 disabled:opacity-25"
                      disabled={!hasNextAlert}
                      onClick={handleNextAlert}
                    >
                      <SvgAlertNextPage width="14" />
                    </button>
                  </Tooltip>
                )}
              </div>
            </div>
          )}
        </div>
        {!hiddenButtons?.includes("share") && (
          <ShareAlertModal
            isOpen={isModalOpen}
            onRequestClose={() => setIsModalOpen(false)}
            alertId={activeAlert?.id}
          />
        )}
        {!hiddenButtons?.includes("merge") && (
          <AlertMergeCaseModal
            isModalOpen={mergeModalOpen}
            setIsModalOpen={(open) => setMergeModalOpen(open)}
            alertId={activeAlert?.id}
            onMerged={() => {
              activeAlert.status = ALERT_PROCESS_STATUS_SDK.Investigate;
              setActiveAlert({
                ...activeAlert,
              });
            }}
          />
        )}
        {!hiddenButtons?.includes("gpt") && (
          <GptAnalysisModal
            visible={gptModalOpen}
            onClose={() => setGptModalOpen(false)}
            alert={activeAlert}
          />
        )}
        {!hiddenButtons?.includes("addRecord") && (
          <CropAlertImgForGptRawModal
            activeAlert={activeAlert}
            isOpen={cropAlertAreaModalOpen}
            onRequestClose={() => setCropAlertAreaModalOpen(false)}
            onFinish={handleCropImgUploaded}
          />
        )}
        {!hiddenButtons?.includes("imgSearch") && (
          <ImgSearchModalControl
            title="Search by Image"
            isOpen={imgSearchModalOpen}
            onRequestClose={() => setImgSearchModalOpen(false)}
            defaultImgUrl={activeAlert?.snapshot?.url}
          />
        )}
        {!hiddenButtons?.includes("addRecord") && (
          <RecordModal
            editType={"add"}
            visible={addRecordModalOpen}
            onClose={() => setAddRecordModalOpen(false)}
            onSave={handleSaveRecord}
            img={imgCropBlob}
          />
        )}
        {!hiddenButtons?.includes("location") && (
          <APIProvider
            apiKey={"AIzaSyAqk45RIVytV7tiTjTy2UISpHEgSWjl1vg"}
            onLoad={() => console.log("Maps API has loaded.")}
          >
            <AlertMap
              visible={alertMapVisible}
              onClose={() => setAlertMapVisible(false)}
              alert={activeAlert}
            />
          </APIProvider>
        )}
        {!hiddenButtons?.includes("playback") && (
          <PlaybackModal
            orgId={activeAlert?.orgId}
            visible={playbackModalOpen}
            onClose={() => setPlaybackModalOpen(false)}
            cameraId={activeAlert?.camera?.id}
            startAt={+activeAlert?.startedAt - 1000 * 60 * 10}
            endAt={+activeAlert?.startedAt + 1000 * 60 * 5}
            initialSeekAt={+activeAlert?.startedAt}
            alertId={activeAlert?.id}
          />
        )}
      </div>
    </>
  );
}
